import { buildIsServiceFn } from '../../utils';

import { SERVICE_TYPES_TRANSFER } from '../../constants';

const isTransferService = buildIsServiceFn(SERVICE_TYPES_TRANSFER);

export default isTransferService;
